<template>
	<div class="supplier-wallet">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Handling Fee</h1>
				<div class="page-header-right text-right ml-a">
				</div>
			</div>
			<div class="row">
				<div class="page-scoreboard col-md-3">
					<div class="box box--primary mb-md-0 mh-120">
						<div class="m-2">
							<h4
								class="text-accent font-weight-bold mb-0"
								:class="{ 'is-loading': isFetching }">
								<span>{{ currency }} {{ formatNumberPlain(scoreBoard.handlingFeeAmount) }}</span>
							</h4>
							<div class="d-flex align-items-baseline justify-content-between">
								<span class="d-block mt-2"><i class="bi bi-wallet"></i> {{ $t('Total Handling Fee') }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="page-content mt-4">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-sm-3">
							<input type="text" class="form-control" placeholder="Order Id..." v-model="keyword" @input="onKeywordChange"/>
						</div>
						<div class="col-sm-9">
							<div class="table-filters d-flex align-items-center justify-content-end ml-a">
								<!-- Clear Filter -->
								<button type="button" class="btn btn-plain btn-sm" @click="clearFilter" v-if="isFilterOn">
									{{ $t('Clear Filter') }}
								</button>
								<div class="filter-date">
									<vuejs-datepicker
										class="mr-3"
										v-model="pickedDate"
										:format="'MMMM yyyy'"
										:bootstrap-styling="true"
										:minimum-view="'month'"
										:maximum-view="'year'"
										name="datepicker"
										id="input-id"
										:calendar-button="true"
										:calendar-button-icon="'bi bi-calendar3'"
										:calendar-button-content="''"
										:calendar-class="'bg-white'"
										:input-class="'bg-white'"
										:wrapper-class="'bg-white'">
									</vuejs-datepicker>
								</div>
								<button
									@click="exportData"
									type="button"
									class="btn btn-sm btn-primary"
									:class="{ 'is-loading': isExporting }"
									>
									<i class="material-icons">save_alt</i>
									<span class="mr-2">{{ $t('Export') }}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="user-wallet-list table-responsive">
					<table class="user-wallet-list-table table table-primary table-striped mb-3">
						<thead>
							<tr>
								<th width="5%" class="text-left">
									No
								</th>
								<th width="5%" class="th-sort text-left">
									Order Id
								</th>
								<th width="15%" class="th-sort text-left">
									Product
								</th>
								<th width="10%" class="th-sort text-left">
									Value
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in orders" :key="index+'-listorder'">
								<td>
									{{ index + 1 }}
								</td>
								<td>
									<span class="text-primary text-bold">
										#{{ item.order_id }}
									</span>
								</td>
								<td>
									{{ item.product }}
								</td>
								<td>
									{{ formatNumberPlain(item.fee_amount) }}
								</td>
							</tr>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div class="list-empty mt-0" v-if="orders.length === 0 || items.length === 0 && isFetching === false">
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no Handling Fee Found yet.</span>
						<span v-else>No Handling Fees was found</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import vuejsDatepicker from 'vuejs-datepicker';
import {
	duplicateVar,
	formatDate,
	downloadFile,
} from '@/lib/helper';
import userApi from '@/api/user';

export default {
	name: 'HandlingFee',
	components: {
		vuejsDatepicker,
	},
	data() {
		return {
			limit: 5,
			page: 1,
			sort_by: 'handling_fee_amount',
			sort: 'desc',
			isFetching: false,
			isShowDetail: false,
			isSearchingSupplier: false,
			isExporting: false,
			items: [],
			orders: [],
			selectedData: {},
			selectedSupplier: null,
			optionSupplier: [],
			last_sync: null,
			isDisabled: true,
			handlingFeeDetail: null,
			handlingFeeOrders: null,
			pickedDate: this.moment().subtract(1, 'months').format(),
			pickedMonth: this.moment().subtract(1, 'months').format('MM'),
			pickedYear: this.moment().subtract(1, 'months').format('YYYY'),
			scoreBoard: {
				handlingFeeAmount: null,
			},
			stashTotal: 0,
			isFetchingStash: false,
			isAll: false,
			currency: 'Rp',
			keyword: '',
		};
	},
	methods: {
		exportData() {
			this.isExporting = true;
			const params = this.getFetchParams();
			if (this.items.length < 1) {
				params.is_stash_processed = false;
			}

			const callback = (response) => {
				this.isExporting = false;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};

			userApi.exportHandlingFee(params, callback, errorCallback);
		},
		resetItems() {
			this.items = [];
			this.orders = [];
			this.page = 1;
			this.scoreBoard.handlingFeeAmount = 0;
			this.isAll = false;
		},
		formatDate,
		getFetchParams() {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
			};

			if (this.selectedSupplier) {
				params.supplier_id = this.selectedSupplier._id;
			}

			if (this.pickedMonth) {
				params.picked_month = this.pickedMonth;
			}

			if (this.pickedYear) {
				params.picked_year = this.pickedYear;
			}

			if (this.keyword) {
				params.keyword = this.keyword;
			}

			return params;
		},
		fetchItems(reset = true) {
			try {
				this.isFetching = true;
				if (reset) {
					this.resetItems();
				}

				const params = this.getFetchParams();

				const callback = (response) => {
					this.isFetching = false;
					this.isSearchingSupplier = false;
					const items = response.data?.handling_fees;
					const orders = items[0]?.orders ?? [];

					if (items.length === 0) {
						this.isAll = true;
					}

					if (items?.length > 0 && orders?.length > 0) {
						this.page++;
						this.items = items[0];
						this.orders = this.orders.concat(orders);
						this.scoreBoard.handlingFeeAmount = items[0].handling_fee_amount;
					} else {
						this.isAll = true;
					}
				};

				const errorCallback = (err) => {
					this.isFetching = false;
					console.log(err);
				};

				userApi.getListHandlingFee(params, callback, errorCallback);
			} catch (error) {
				console.log(error);
			}
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		applyFilter() {
			this.fetchItems(true);
		},
		resetFilter() {
			this.keyword = null;
		},
		clearFilter() {
			this.$router.replace({ query: null });
			this.resetFilter();
			this.applyFilter();
		},
		showDetail(handlingFeeDetail) {
			if (this.handlingFeeDetail && this.handlingFeeDetail._id === handlingFeeDetail._id) {
				this.handlingFeeDetail = null;
				this.handlingFeeOrders = null;
				return;
			}

			this.handlingFeeDetail = duplicateVar(handlingFeeDetail);
			this.handlingFeeOrders = this.handlingFeeDetail.orders ?? [];
		},
		onKeywordChange() {
			this.ooDelay(() => {
				this.fetchItems(true);
			}, 1000);
		},
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
		}),
		isFilterOn() {
			return this.keyword !== '';
		},
	},
	watch: {
		pickedDate() {
			const date = this.moment(this.pickedDate);
			this.pickedMonth = date.format('MM');
			this.pickedYear = date.format('YYYY');
			this.fetchItems(true);
		},
	},
	created() {
		this.fetchItems();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
	.vdp-datepicker__calendar .cell.selected {
		background: '$primary_color' !important;
	}
</style>
